import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import es from "./es.json";
import en from "./en.json";

const resources = {
  es: {
    translation: es.translation,
  },
  en: {
    translation: en.translation,
  },
};

const supportedLngs = ["es", "en"];

export const initializeI18n = () => {
  const getLanguage = () => {
    // Asegurarse de que Office.context está disponible
    if (window.Office && Office.context && Office.context.displayLanguage) {
      const officeLanguage = Office.context.displayLanguage.split("-")[0];
      return supportedLngs.includes(officeLanguage) ? officeLanguage : "es";
    }
    return "es"; // Fallback si Office no está disponible
  };

  return i18n.use(initReactI18next).init({
    resources,
    lng: getLanguage(),
    fallbackLng: "es",
    interpolation: {
      escapeValue: false,
    },
  });
};